module.exports = __webpack_public_path__ + "img/selected1-min.df519223.png";